import type { ChannelMixData } from '../../types/dashboard'
import { fmt } from '../../lib/dashboardHelpers'
import { useChartColors } from '../../hooks/useChartColors'

export default function ChannelMixBar({ mix }: { mix: ChannelMixData }) {
    const colors = useChartColors()
    if (!mix) return null
    const total = mix.inStore + mix.online
    let inStorePct = 0
    let onlinePct = 0

    if (total === 0) {
        inStorePct = 50
        onlinePct = 50
    } else {
        inStorePct = (mix.inStore / total) * 100
        onlinePct = (mix.online / total) * 100
    }

    return (
        <div className="chart-panel" style={{ height: '100%' }}>
            <div className="chart-panel-title">Channel Mix</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12, fontSize: 14, fontWeight: 500 }}>
                <div style={{ color: colors.secondary }}>In-Store: {fmt(mix.inStore, 'currency')} <span style={{ opacity: 0.7, fontWeight: 400 }}>({inStorePct.toFixed(1)}%)</span></div>
                <div style={{ color: colors.primary }}>Online: {fmt(mix.online, 'currency')} <span style={{ opacity: 0.7, fontWeight: 400 }}>({onlinePct.toFixed(1)}%)</span></div>
            </div>
            <div style={{ width: '100%', height: 16, backgroundColor: 'var(--kpi-flat-bg)', borderRadius: 8, overflow: 'hidden', display: 'flex' }}>
                <div style={{ width: `${inStorePct}%`, backgroundColor: colors.secondary, height: '100%', transition: 'width 1s ease' }} />
                <div style={{ width: `${onlinePct}%`, backgroundColor: colors.primary, height: '100%', transition: 'width 1s ease' }} />
            </div>
        </div>
    )
}
